import { createElement } from 'react'
import { FlagCell } from 'routes/shared/components'
import { allTeamsFavorite } from './components/favoriteButton'

export const createColumns = () => [
  {
    Header: 'Team Name',
    accessor: 'teamName',
    minWidth: 200,
    width: 200,
  },

  {
    Header: 'Sport',
    accessor: 'sport',
  },
  {
    Header: 'Jurisdiction',
    accessor: 'jurisdiction.logo',
    Cell: FlagCell,
  },
  {
    Header: 'Team Website',
    accessor: 'teamWebsite',
  },
  {
    Header: 'Favorite',
    id: 'controls',
    width: 180,
    minWidth: 180,
    accessor: (value) => value,
    Cell: (props) => createElement(allTeamsFavorite, { ...props }),
  },
]
